<template>
    <div>
      <div v-if='session.contents'>
        You're already logged in!
        Click here to continue
        Click here to log out
      </div>
      <template v-else>
        <component :is='component'/>
        <h3 v-if='component==="login"' ><router-link to='/signup'>Or Signup</router-link></h3>
        <h3 v-if='component==="signup"'><router-link to='/login'>Or Login</router-link></h3>
      </template>
    </div>
</template>

<script>
import session from "../lib/session";
import signup from "./signup";
import login from "./login";
export default {
  props: {
    component: { default: "login" }
  },
  data() {
    return {
      session: session
    };
  },
  watch: {
    "session.contents": function(contents, prev) {
      // if we went from not authed to authed, redirect to /
      if (contents && !prev) {
        this.$router.push("/");
      }
    }
  },
  components: {
    signup,
    login
  }
};
</script>

<style scoped lang='scss'>
.header {
  > div {
    display: flex;
    align-items: center;
  }
  flex-grow: 0;
  flex-shrink: 0;
  height: 45px;
  font-family: "League Spartan", sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 32px;
  background: $gray-1;
  color: $primary;
}
h2 {
  margin: 0px 18px;
}
h3 {
  margin: 0px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/registration.vue